export const TRANSACTION_ORIGIN_TYPES = {
  1: "Наша карта в нашем устр.",
  2: "Чужая карта в нашем устр.",
  3: "Наша карта в чужом устр.",
  4: "Чужая карта в чужом устр.",
};
export const TRANSACTION_UCAF_TYPES = {
  0: "Без UCAF",
  1: "Attempt",
  2: "Full 3DS",
};

export const TRANSACTION_SMS_STATUSES = {
  NOT_PROCESSED: 0,
  SENT: 1,
  SWITCHED_OFF: 2,
  ERROR_PROC: 666,
  ERROR_PROVIDER: 667,
};



// WEBPACK FOOTER //
// ./src/components/processing/CONSTANTS.js